export const HOME_STARRED_PAGES_QUERY_TASK_NAME = 'HomeStarredPagesQuery';
